import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { 
  LayoutDashboard, 
  Users, 
  LogOut, 
  ChevronLeft, 
  ChevronRight, 
  Terminal,
  Radio,
  Menu,
  X
} from "lucide-react";
import "./AdminSidebar.css";

export default function AdminSidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const navigate = useNavigate();

  // Check screen size on mount and resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setIsCollapsed(false); // Reset collapse on mobile
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    localStorage.removeItem('isAdmin');
    navigate("/adminLogin");
  };

  // Close sidebar on mobile when clicking a link
  const handleNavLinkClick = () => {
    if (window.innerWidth <= 1024) {
      setIsMobileOpen(false);
    }
  };

  return (
    <>
      {/* Mobile Menu Toggle Button */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        aria-label={isMobileOpen ? "Close Menu" : "Open Menu"}
      >
        {isMobileOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div 
          className="mobile-overlay"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <aside className={`admin-sidebar ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "mobile-open" : ""}`}>
        {/* ===== SIDEBAR HEADER ===== */}
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="logo-icon-node">
              <Terminal size={16} className="terminal-brand-icon" />
              <Radio size={10} className="sidebar-pulse-signal" />
            </div>
            {!isCollapsed && (
              <span className="logo-brand-text">
                era<span>X</span> <span className="control-tag">Core</span>
              </span>
            )}
          </div>
          
          <button 
            type="button"
            className="collapse-toggle-btn"
            onClick={() => setIsCollapsed(!isCollapsed)}
            aria-label={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
          >
            {isCollapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
          </button>
        </div>

        {/* ===== NAVIGATION ===== */}
        <nav className="sidebar-nav-container">
          <span className="nav-section-label">{isCollapsed ? "SYS" : "System Diagnostics"}</span>
          <ul className="nav-list-group">
            <li>
              <NavLink 
                to="/admin/dashboard" 
                className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                onClick={handleNavLinkClick}
              >
                <LayoutDashboard size={20} className="link-icon" />
                {!isCollapsed && <span>Control Center</span>}
              </NavLink>
            </li>
          </ul>

          <span className="nav-section-label">{isCollapsed ? "SEC" : "Authority Management"}</span>
          <ul className="nav-list-group">
            <li>
              <NavLink 
                to="/admin/users" 
                className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                onClick={handleNavLinkClick}
              >
                <Users size={20} className="link-icon" />
                {!isCollapsed && <span>EraX User</span>}
              </NavLink>
            </li>
          </ul>
        </nav>

        {/* ===== FOOTER ===== */}
        <div className="sidebar-footer-profile">
          <div className="profile-pod-wrapper">
            <div className="operator-avatar">
              <span className="avatar-initials">AM</span>
              <div className="active-status-ring"></div>
            </div>
            
            {!isCollapsed && (
              <div className="operator-meta-details">
                <span className="operator-name">Alex Mercer</span>
                <span className="operator-role">Root Admin</span>
              </div>
            )}
          </div>

          <button 
            type="button" 
            className="sidebar-logout-btn" 
            onClick={handleLogout}
            title="Disconnect Session"
          >
            <LogOut size={18} />
            {!isCollapsed && <span>Disconnect</span>}
          </button>
        </div>
      </aside>
    </>
  );
}